// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { ShieldOff } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconShieldOff(props: any) {
    return <IconBase icon={ShieldOff} {...props} />
  }

  export default IconShieldOff
  